import React from 'react';
import {
  arrayOf,
  bool,
  func,
  shape,
  oneOf,
  oneOfType,
  node,
  number,
  string
} from 'prop-types';

import BaseComponent from '../../.internal/BaseComponent';
import Trigger from '../../.internal/trigger/Trigger';
import MultiStepContainer from './components/multi_step_container/MultiStepContainer';

import './MultiStepTooltip.scss';

const POSITIONS = [
  'top',
  'top-left',
  'top-right',
  'bottom',
  'bottom-left',
  'bottom-right',
  'right',
  'right-top',
  'right-bottom',
  'left',
  'left-top',
  'left-bottom'
];

/**
 * @deprecated
 */
export default class MultiStepTooltip extends BaseComponent {
  onNext = () => {
    const { onNext, stepId } = this.props;

    onNext(stepId);
  };

  handlePopoverOnChange = status => {
    this.setState({
      status
    });
  };

  render() {
    const {
      activeStep,
      className,
      children,
      content,
      displayClose,
      labelNext,
      stepId,
      stepNumber,
      stepTotal,
      position
    } = this.props;

    const visible = activeStep === stepId;

    return (
      <Trigger
        autoAdjust
        overlayClassName="overlay-container"
        overrideVisible={visible}
        popup={
          <MultiStepContainer
            className={className}
            displayClose={displayClose}
            labelNext={labelNext}
            onNext={this.onNext}
            position={position}
            stepNumber={stepNumber}
            stepTotal={stepTotal}
          >
            {content}
          </MultiStepContainer>
        }
        action="programmatic"
        position={position}
      >
        {children}
      </Trigger>
    );
  }
}

MultiStepTooltip.propTypes = {
  activeStep: number,
  children: node.isRequired,
  className: string,
  content: oneOfType([arrayOf(node), node]),
  displayClose: bool,
  id: string,
  labelNext: string,
  onNext: func.isRequired,
  position: oneOf(POSITIONS),
  stepId: string.isRequired,
  stepNumber: number.isRequired,
  stepTotal: number.isRequired,
  style: shape({})
};

MultiStepTooltip.defaultProps = {
  activeStep: 0,
  className: undefined,
  content: '',
  displayClose: false,
  id: undefined,
  labelNext: 'Next',
  position: undefined,
  style: {}
};
